import * as geoLoc from 'vue-browser-geolocation';

export default ({ app }, inject) => {
  inject('localisation', geoLoc.default);
};
